export default __webpack_public_path__ + "static/media/linkedin_socialicon.f4d9dc1d.svg";